import {Component, Injectable, OnInit} from '@angular/core';
import {AuthenticateService} from '../../../common/services/Authenticate.service';
import {ModalInfoService} from '../../../common/services/ModalInfo.service';
import {FlashMessagesService} from 'angular2-flash-messages';
import {EvsAddressService} from '../../../common/services/EvsAddress.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router } from '@angular/router';

/**
 * This class represents the lazy loaded HomeComponent.
 */
declare var $: any;

@Component({
    selector: 'app-register',
    templateUrl: 'register-v3.component.html',
    providers: [EvsAddressService]
})

@Injectable()
export class RegisterComponent implements OnInit {

    public model: any = {};
    public message: any; //{ class: string, content: string }
    public check: boolean = false;
    public cities: Array<any> = [];
    public districts: Array<any> = [];
    public FormRegister: FormGroup;

    constructor(private mdInfo: ModalInfoService,
                private authenService: AuthenticateService,
                private router: Router,
                public addressService: EvsAddressService,
                private fb: FormBuilder) {

        let body = document.getElementsByTagName('body')[0];
        body.classList.add('animsition');   //add the class
        body.classList.add('layout-full');   //add the class
    }

    ngOnInit() {
        this.createForm();

        this.getCity();
        var that = this;
        $('#city').select2({placeholder: '-- Chọn Tỉnh/TP --', allowClear: false});
        $('#district').select2({placeholder: '-- Chọn Quận/Huyện --', allowClear: false});
        $('#city').on('select2:select', function (e) {
            $('.select2-selection__rendered').removeAttr('title');
            var id = e.target.value;
            that.loadDistrictData(id);
        });
        $('#district').on('select2:select', function (e) {
            $('.select2-selection__rendered').removeAttr('title');
        });
    }

    createForm() {
        this.FormRegister = this.fb.group({
            'username': [null, Validators.required],
            'password': [null, Validators.required],
            'confirm_password': [null, Validators.required],
            'name': [null],
            'address': [null],
            'district_id': [null],
            'city_id': [null],
            'phone': [null],
            'emmail': [null],
            'website': [null],
        });
    }

    onSubmit(data) {
        this.message=null;
        this.authenService.register(this.model).toPromise().then(res => {
            if (res.error == false) {
                this.message = {'class':'alert-success', 'content':'Đăng ký tài khoản thành công'};
                this.router.navigate(['/login']);
            } else {
                this.message = {'class':'alert-danger', 'content':res.message};
            }
        }).catch((err: any) => {
            this.message = {'class':'alert-danger', 'content':err.message};
        })
    }

    getCity() {
        this.addressService.getCities().subscribe(res => {
            let citiesList = [];
            res.data.cities.forEach((c: any) => {
                citiesList.push({
                    value: c.id,
                    label: c.name,
                    id: c.id,
                });
            });
            this.cities = citiesList;
        });
    }

    loadDistrictData(id: number) {
        this.addressService.getDistrict({city_id: id}).toPromise().then(res => {
            let districts = [];
            res.data.districts.forEach((c: any) => {
                districts.push({
                    value: c.id,
                    label: c.name,
                    id: c.id,
                });
            });
            this.districts = districts;
        })
    }


}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/auth/register.component.ts